export class StorageMoveRequest {
    public idSectorSolicitation?: number;
    public idStorage?: number;
    public idStorageAmountLocation: number;
    public newIdLocation: number;
    public amount: number;
}